import { createCall, spellbook } from "@sdk/spellbook";

import { withAccountAuthHeaders } from "./apiHelpers";

const endpoint = spellbook("/organisations/{organisationId}/departments").GET();

export type GetCompanyDepartmentsRes = typeof endpoint.types.Res;

export async function getCompanyDepartments(
    params: typeof endpoint.types.P,
    query: typeof endpoint.types.Q,
) {
    const call = createCall(endpoint, (r) => fetch(withAccountAuthHeaders(r)));

    return await call({ query, params });
}
